import { render, staticRenderFns } from "./ModuleWithPermissions.vue?vue&type=template&id=ac8e765c&scoped=true&"
import script from "./ModuleWithPermissions.vue?vue&type=script&lang=ts&"
export * from "./ModuleWithPermissions.vue?vue&type=script&lang=ts&"
import style0 from "./ModuleWithPermissions.vue?vue&type=style&index=0&id=ac8e765c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8e765c",
  null
  
)

export default component.exports